import { DSCardWrapper } from "@components/design-system/molecules";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

const TemplateFormButton = ({
  icon,
  title,
  description,
  isSelected,
  name,
  value,
  checked,
  onChange,
  onClick = () => {},
  disableButton,
  dataTestId,
}) => {
  return (
    <div
      className={`flex-1 ${disableButton && !isSelected ? "opacity-50" : ""}`}
    >
      <DSCardWrapper
        variant={isSelected ? "info" : "default"}
        interactive={!disableButton}
        onClick={disableButton ? undefined : onClick}
        padding="p-sm"
        dataTestId={dataTestId}
      >
        <label
          className={`flex items-center gap-md ${disableButton ? "cursor-not-allowed" : "cursor-pointer"}`}
        >
          <input
            type="radio"
            name={name}
            value={value}
            checked={checked}
            onChange={onChange}
            disabled={disableButton}
            className="sr-only"
          />
          <FontAwesomeIcon
            icon={icon}
            size="3x"
            className="text-brand"
          />
          <div className="flex flex-col">
            <span className="font-semibold">{title}</span>
            <span className="text-xs font-normal text-secondary">
              {description}
            </span>
          </div>
        </label>
      </DSCardWrapper>
    </div>
  );
};

export default TemplateFormButton;
